import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Button.module.scss'

/** ``danger`` só para ação destrutiva de confirmação (ex.: "Descartar"). */
export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize = 'sm' | 'md'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  leadingIcon?: ReactNode
  trailingIcon?: ReactNode
  /** Fill the container width. */
  block?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', leadingIcon, trailingIcon, block, className, children, type, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cn(
        styles.button,
        styles[`variant-${variant}`],
        styles[`size-${size}`],
        block && styles.block,
        className,
      )}
      {...rest}
    >
      {leadingIcon ? <span className={styles.icon} aria-hidden>{leadingIcon}</span> : null}
      {children ? <span className={styles.label}>{children}</span> : null}
      {trailingIcon ? <span className={styles.icon} aria-hidden>{trailingIcon}</span> : null}
    </button>
  )
})
